<template>
  <div class="layout-home">
    <div class="header flex flex-vc">
      <div class="logo-wrapper">
        <div class="logo bg-full"></div>
        <div class="company-name" v-if="simpleMode">丨湛江市有爱有家婚姻服务有限公司</div>
      </div>
      <div class="tabs-wrapper" v-if="!simpleMode">
        <router-link v-if="hasAccess('guest')" to="/user" class="tab-item">嘉宾列表</router-link>
        <router-link v-if="hasAccess('account')" to="/account" class="tab-item">员工账号管理</router-link>
        <router-link v-if="hasAccess('applet')" to="/applet" class="tab-item">手机站内容管理</router-link>
      </div>
      <div class="nickname-wrapper flex" @click="showMenu = true">
        <div class="nickname poi">{{ userInfo.nickname || userInfo.username || '游客' }}</div>
        <div class="arrow bg-full poi" :class="{ reverse: showMenu }"></div>
        <div class="cover" @click.stop v-show="showMenu"></div>
        <div class="menu-wrapper" v-click-outside="hideMenu" v-show="showMenu" @click="hideMenu">
          <template v-if="hasAccess('other.switchMode')">
            <div class="menu-item" @click="switchSimpleMode(true)" v-if="!simpleMode">
              <i class="menu-icon" :style="{ backgroundImage: `url(${require('@/assets/img/icon/switch.png')})` }"></i>
              <span>客户展示模式</span>
            </div>
            <div class="menu-item" @click="switchSimpleMode(false)" v-else>
              <i class="menu-icon" :style="{ backgroundImage: `url(${require('@/assets/img/icon/switch.png')})` }"></i>
              <span>管理编辑模式</span>
            </div>
          </template>
          <div class="menu-item" @click="handleLogout">
            <i class="menu-icon" :style="{ backgroundImage: `url(${require('@/assets/img/icon/logout.png')})` }"></i>
            <span>退出登录</span>
          </div>
        </div>
      </div>
    </div>
    <div class="main auto">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'

import ClickOutside from '@/directives/click-outside'

export default {
  directives: {
    'click-outside': ClickOutside,
  },
  mounted() {
    const accessRoutes = []
    if (this.hasAccess('guest')) {
      accessRoutes.push('user')
    }
    if (this.hasAccess('account')) {
      accessRoutes.push(...['admin', 'role', 'menu'])
    }
    if (this.hasAccess('applet')) {
      accessRoutes.push('applet')
    }
    if (!accessRoutes.includes(this.$route.name)) {
      this.$router.replace({ name: accessRoutes.shift() || 'user' })
    }
  },
  data() {
    return {
      showMenu: false,
    }
  },
  computed: {
    ...mapState(['userInfo', 'simpleMode']),
  },
  methods: {
    ...mapActions(['logout']),
    ...mapMutations(['setSimpleMode']),
    handleLogout() {
      this.logout()
    },
    hideMenu() {
      this.showMenu = false
    },
    switchSimpleMode(val) {
      this.setSimpleMode(val)
    },
  },
  watch: {
    simpleMode(val) {
      if (val && this.$route.name !== 'user') {
        this.$router.replace({ name: 'user' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.layout-home {
  min-height: 100vh;
  padding-top: 56px;
  padding-bottom: 56px;
}
.header {
  background-color: #fff;
  height: 56px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.03);
  display: flex;
  align-items: center;
  justify-content: center;
  .logo-wrapper {
    display: flex;
    align-items: center;
    position: absolute;
    left: 24px;
    top: 50%;
    transform: translateY(-50%);
  }
  .logo {
    width: 94px;
    height: 32px;
    background-image: url(~@/assets/img/home/logo.png);
  }
  .company-name {
    height: 30px;
    font-size: 24px;
    font-weight: 400;
    line-height: 30px;
    color: #ff8ca9;
  }
  .tabs-wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
  }
  .tab-item {
    height: 100%;
    color: #333333;
    display: flex;
    align-items: center;
    height: 40px;
    width: 148px;
    padding: 0 40px;
    font-size: 18px;
    white-space: nowrap;
    justify-content: center;
    border-radius: 101px;
    margin: 0 58px;
    // + .tab-item {
    //   margin-left: 116px;
    // }
    ::v-deep &.router-link-active {
      color: #fff;
      background-color: #ff8ca9;
    }
  }
  .nickname-wrapper {
    position: absolute;
    right: 24px;
    display: flex;
    align-items: center;
    top: 50%;
    transform: translateY(-50%);
    height: 24px;
    font-size: 16px;
    line-height: 24px;
    .nickname {
      min-width: 48px;
    }
    .arrow {
      width: 24px;
      height: 24px;
      background-image: url(~@/assets/img/icon/arrow.png);
      margin-left: 4px;
      transition: transform 0.3s;
      &.reverse {
        transform: rotate(180deg);
      }
    }
    .logout {
      &:hover {
        color: #fff;
      }
    }
    .cover {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }
  }
  .menu-wrapper {
    position: absolute;
    top: 28px;
    right: -5px;
    width: 140px;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.02);
    padding: 8px 0;
    .menu-item {
      height: 32px;
      cursor: pointer;
      font-size: 14px;
      color: #333333;
      display: flex;
      align-items: center;
      padding-left: 16px;
      &:hover {
        color: #ff8ca9;
      }
    }
    .menu-icon {
      width: 13px;
      height: 14px;
      background: center/100% 100% no-repeat;
      margin-right: 10px;
    }
  }
}
.main {
  width: 1200px;
}
</style>
